import { PiStrategy } from "react-icons/pi";
import { PiStrategyBold } from "react-icons/pi";
import { TbTools } from "react-icons/tb";
import { MdOutlineCases } from "react-icons/md";
import { MdPeopleOutline } from "react-icons/md";
import { HiOutlineTrendingUp } from "react-icons/hi";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import React from "react";
import {Link} from "react-scroll";
import { FaArrowRightLong } from "react-icons/fa6";

function AdvantagesOne({advantagesData}) {

    //console.log(advantagesData)

    const styles = "border border-gray-200 p-6 rounded-lg h-full relative overflow-hidden";

    return (
        advantagesData ?
            <section className="pb-20">
                <div className="container mx-auto p-4 sm:p-0">

                    <ScrollAnimation animateIn="animate__fadeInUp"><h6 className="bg-[#F3FF80] w-max px-3 py-1 mb-4 rounded-2xl mx-auto">Ваші можливості</h6></ScrollAnimation>
                    <ScrollAnimation animateIn="animate__fadeInUp"><h2 className="text-4xl mb-4 uppercase text-center">{advantagesData.advantages_title}</h2></ScrollAnimation>
                    {/*<p className="mb-4">{advantagesData.advantages_absaz[0].advantages_absaz_text}</p>*/}

                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                        {
                            advantagesData.advantages_repeater ?
                                advantagesData.advantages_repeater.map((item, value) => (

                                    <div className={value < 5 ? " sm:order-" + value : ''} key={value}>
                                        <ScrollAnimation animateIn="animate__fadeInUp h-full">
                                            <div className={styles}>
                                                <div className="mb-2.5 relative z-20">
                                                    {
                                                        value === 0 ? <PiStrategyBold className="text-3xl"/> : ''
                                                    }
                                                    {
                                                        value === 1 ? <TbTools className="text-3xl"/> : ''
                                                    }
                                                    {
                                                        value === 2 ? <MdOutlineCases className="text-3xl"/> : ''
                                                    }
                                                    {
                                                        value === 3 ? <MdPeopleOutline className="text-3xl"/> : ''
                                                    }
                                                    {
                                                        value === 4 ? <HiOutlineTrendingUp className="text-3xl"/> : ''
                                                    }
                                                </div>
                                                <h4 className="mb-2.5 relative z-20">{item.advantages_repeater_title}</h4>
                                                <p className="relative z-20">{item.advantages_repeater_text}</p>
                                                <div className="rounded-full w-[200px] h-[200px] absolute -left-[100px] -top-[100px] bg-[#F3FF80]/20 z-10"></div>
                                            </div>
                                        </ScrollAnimation>
                                    </div>

                                )) : ''
                        }

                        <div className="sm:order-0">
                            <ScrollAnimation animateIn="animate__fadeInUp h-full">
                                <p className="text-[18px] mb-4">{advantagesData.advantages_absaz[1].advantages_absaz_text}</p>
                                <Link to="formats" className="text-[#003366] uppercase font-bold flex items-center gap-2" smooth={true} offset={-70} duration={500}>Взяти участь <FaArrowRightLong /></Link>
                            </ScrollAnimation>
                        </div>


                    </div>
                </div>
            </section> : ''
    )
}

export default AdvantagesOne